import {
  SHOP_USER_LIST, SHOP_USER_LIST_FAILURE, SHOP_USER_LIST_SUCCESS
} from '../mutation-types'

export default {
  state: {
    users: [],
    nextPage: null,
    currentPage: null,
    loading: true
  },
  getters: {
    shopUserListUsersData: state => {
      return state.users
    },
    shopUserListNextPage: state => {
      return state.nextPage
    },
    shopUserListCurrentPage: state => {
      return state.currentPage
    },
    shopUserListLoading: state => {
      return state.loading
    }
  },
  actions: {
    [SHOP_USER_LIST] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shops/' + params.data.shop_id + '/users'
      var callback = () => {}
      if (params) {
        data = params.data
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_USER_LIST_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHOP_USER_LIST_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_USER_LIST_FAILURE] (state, params) {
      console.log('DEPARTMENT_USER_LIST_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [SHOP_USER_LIST_SUCCESS] (state, params) {
      console.log('DEPARTMENT_USER_LIST_SUCCESS')
      var data = params.data
      var reSearch = false
      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }
      if (reSearch) {
        // 再検索
        state.users = data.data
        if (data.meta['next-page'] === null) {
          state.nextPage = null
        }
      } else {
        state.loading = false
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.users = state.users.concat(data.data)
          state.currentPage = data.meta['current-page']
        } else {
          state.users = data.data
          state.currentPage = 1
        }
        if (data.links && data.links['next']) {
          state.nextPage = data.links['next']
        } else {
          state.nextPage = null
        }
      }
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop/user-list.js